import { render } from "./PrintsSlider.vue?vue&type=template&id=642bbcb5&scoped=true"
import script from "./PrintsSlider.vue?vue&type=script&lang=js"
export * from "./PrintsSlider.vue?vue&type=script&lang=js"

import "./PrintsSlider.vue?vue&type=style&index=0&id=642bbcb5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642bbcb5"]])

export default __exports__